import type { CSSProperties } from 'react';

import type { DeleteImportResult } from '@/api/queries/contacts';
import { Button, Icon } from '@/components/ui';
import { useModal } from '@/components/modal/useModal';

const STAT_BASE: CSSProperties = {
  padding: 16,
  borderRadius: 'var(--radius-md)',
  textAlign: 'center',
  border: '1px solid var(--border)',
};

export function ContactDeleteImportResultDialog({ result }: { result: DeleteImportResult }) {
  const { closeModal } = useModal();

  return (
    <>
      <div className="ds-modal-head">
        <h2>Delete import result</h2>
      </div>
      <div className="ds-modal-body">
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            padding: '8px 12px',
            background: 'var(--green-soft)',
            color: '#086940',
            borderRadius: 'var(--radius-sm)',
            fontSize: 12.5,
            marginBottom: 16,
          }}
        >
          <Icon name="check" size={14} />
          {result.deleted} contact{result.deleted === 1 ? '' : 's'} deleted.
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 10 }}>
          <Stat label="Emails" value={result.total} tone="brand" />
          <Stat label="Deleted" value={result.deleted} tone="green" />
          <Stat label="Not found" value={result.notFound} tone={result.notFound > 0 ? 'red' : 'slate'} />
        </div>
      </div>
      <div className="ds-modal-foot">
        <span style={{ flex: 1 }} />
        <Button variant="primary" onClick={closeModal}>
          Close
        </Button>
      </div>
    </>
  );
}

function Stat({
  label,
  value,
  tone,
}: {
  label: string;
  value: number;
  tone: 'brand' | 'green' | 'red' | 'slate';
}) {
  const TONE: Record<typeof tone, { bg: string; fg: string }> = {
    brand: { bg: 'var(--brand-soft)', fg: 'var(--brand)' },
    green: { bg: 'var(--green-soft)', fg: 'var(--green)' },
    red: { bg: 'var(--red-soft)', fg: 'var(--red)' },
    slate: { bg: 'var(--slate-soft)', fg: 'var(--slate)' },
  };
  const c = TONE[tone];
  return (
    <div style={{ ...STAT_BASE, background: c.bg, borderColor: 'transparent' }}>
      <div
        style={{
          fontFamily: 'var(--font-ui)',
          fontSize: 22,
          fontWeight: 600,
          color: c.fg,
          letterSpacing: '-0.02em',
          lineHeight: 1.1,
        }}
      >
        {value}
      </div>
      <div style={{ fontSize: 11.5, color: c.fg, marginTop: 4 }}>{label}</div>
    </div>
  );
}
